import { IntegrationType } from '@/shared/types/integration';

const CHANNEL_TRANSLATION_KEYS: Record<IntegrationType, string> = {
  [IntegrationType.EMAIL]: 'channels.email',
  [IntegrationType.FACEBOOK]: 'channels.facebook',
  [IntegrationType.FRONT]: 'channels.front',
  [IntegrationType.INFOBIP_RCS]: 'channels.infobip-rcs',
  [IntegrationType.INFOBIP_SMS]: 'channels.infobip-sms',
  [IntegrationType.INSTAGRAM]: 'channels.instagram',
  [IntegrationType.INTERCOM]: 'channels.intercom',
  [IntegrationType.LIVECHAT]: 'channels.livechat',
  [IntegrationType.SLACK]: 'channels.slack',
  [IntegrationType.SMARTLEAD]: 'channels.smartlead',
  [IntegrationType.SUNCO]: 'channels.sunco',
  [IntegrationType.TELNYX_VOICE]: 'channels.telnyx-voice',
  [IntegrationType.TWILIO_VOICE]: 'channels.twilio-voice',
  [IntegrationType.WEB_VOICE]: 'channels.web-voice',
  [IntegrationType.AGORA_VOICE]: 'channels.agora-voice',
  [IntegrationType.VIBER]: 'channels.viber',
  [IntegrationType.MSTAT_VIBER]: 'channels.mstat-viber',
  [IntegrationType.WEB]: 'channels.web',
  [IntegrationType.WHATSAPP]: 'channels.whatsapp',
  [IntegrationType.ZENDESK]: 'channels.zendesk',
  [IntegrationType.CUSTOM]: 'channels.custom',
};

export const getChannelKey = (channelType: IntegrationType | undefined): string =>
  (channelType && CHANNEL_TRANSLATION_KEYS[channelType]) || 'channels.unknown';

const CHANNEL_DISPLAY_NAMES: Record<string, string> = {
  whatsapp: 'WhatsApp',
  'mstat-viber': 'Viber',
  'infobip-sms': 'SMS',
  'infobip-rcs': 'RCS',
  'twilio-voice': 'Voice',
  'telnyx-voice': 'Voice',
  'agora-voice': 'Voice',
  voice: 'Voice',
  email: 'Email',
};

export const getChannelDisplayName = (integrationType: IntegrationType | string): string =>
  CHANNEL_DISPLAY_NAMES[integrationType] || integrationType;
